import { useTranslation } from 'react-i18next';
import { cn } from '../../lib/utils';

export type EntryGender = 'male' | 'female';

interface GenderChoiceProps {
  /** The radios' group name — distinct per form on a page that shows several. */
  name: string;
  value: EntryGender | null;
  onChange: (value: EntryGender) => void;
}

/**
 * Male or female: the gender of the class somebody competes in, and nothing
 * more (no "other", no free text) — the question the entry forms ask when it
 * is not known yet. Two radios rather than a select: two answers, one tap.
 */
export default function GenderChoice({ name, value, onChange }: GenderChoiceProps) {
  const { t } = useTranslation();

  return (
    <div className="flex flex-wrap gap-2">
      {(['male', 'female'] as const).map((option) => (
        <label
          key={option}
          className={cn(
            'flex cursor-pointer items-center gap-2 rounded-md border px-3 py-1.5 text-sm',
            value === option && 'border-primary ring-1 ring-primary'
          )}
        >
          <input
            type="radio"
            name={name}
            value={option}
            checked={value === option}
            onChange={() => onChange(option)}
            className="accent-primary"
          />
          {t(`stageEntry.dialog.${option}`)}
        </label>
      ))}
    </div>
  );
}
